import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { TableColumnType } from "src/app/constants/table";
import { BeneficiariesResponse, BeneficiaryPayload, BenefitBeneficiaryCard } from "src/app/models/beneficiary";
import { BenefitSummary } from "src/app/models/benefit-summary";
import { TableColumn } from "src/app/models/table";

@Component({
    selector: 'mwp-benefit-enrollment-wizard-beneficiaries',
    templateUrl: './beneficiaries-wizard.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BeneficiariesWizardComponent implements OnInit {
    @Input() public beneficiariesResponse: BeneficiariesResponse;
    @Input() public isCheckoutWizard: boolean;
    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();

    public benefitSummaryTableData: MatTableDataSource<BenefitSummary> = new MatTableDataSource<BenefitSummary>();;
    public benefitSummaryColumns: TableColumn[] = [
        {
            columnName: 'Benefit',
            propertyId: 'enrollmentName',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Tier',
            propertyId: 'tier',
            columnType: TableColumnType.label,
            width: '27%',
        },
        {
            columnName: 'Effective',
            propertyId: 'effectiveDate',
            columnType: TableColumnType.label,
            width: '15%',
        },
        {
            columnName: 'Cost',
            propertyId: 'deductionForDisplay',
            columnType: TableColumnType.label,
            width: '15%',
        },
    ];

    public benefitBeneficiaryCard: BenefitBeneficiaryCard;
    public instructionHTML: string;

    constructor(
    ) {
    }

    ngOnInit() {
        this.instructionHTML = this.beneficiariesResponse.instructionHTML;
        this.benefitBeneficiaryCard = this.beneficiariesResponse.benefitBeneficiaryCards[0];
        this.benefitSummaryTableData.data = this.benefitBeneficiaryCard.genericBenefitSummaryModel.summaryBenefitCards;
    }

    public cancel(): void {
        this.emitCancel.emit();
    }

    public submitComplete($event: BeneficiaryPayload): void {
        this.emitComplete.emit($event);
    }
}